import StatusPill from '../ui/StatusPill';

// Delegates to the shared StatusPill status→color map (design system v3) —
// active/pending_funding/matured/closed all resolve consistently with
// every other status pill in the app now, rather than this component's
// own tone table.
export default function InvestmentStatusBadge({ status }) {
  return <StatusPill status={status} />;
}
